/*
 * JH: erbjudanderäknare ("2 för 600" m.fl.), se snippets/jh-offer-progress.liquid.
 *
 * Liquid ritar startläget utifrån varukorgen vid sidladdning. Det här skriptet räknar om
 * mätaren och texterna när varukorgen ändras (lagt i, ändrat antal, tagit bort), genom att
 * hämta /cart.js och räkna de rader vars produkt-id finns i erbjudandets samling.
 */
(function () {
  'use strict';

  if (window.jhOfferProgressInit) return;
  window.jhOfferProgressInit = true;

  var EVENTS = ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:refresh', 'theme:cart:close'];
  var timer = null;

  function root() {
    return (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  }

  function money(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyFormat) {
      return window.theme.formatMoney(cents, window.theme.moneyFormat);
    }
    return Math.round(cents / 100) + ' kr';
  }

  function fill(template, vars) {
    return (template || '').replace(/\|\|(\w+)\|\|/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : match;
    });
  }

  function render(el, cart) {
    var ids;
    try {
      ids = JSON.parse(el.dataset.ids || '[]');
    } catch (e) {
      return;
    }
    var qty = parseInt(el.dataset.qty, 10) || 2;
    var type = el.dataset.offerType || 'price';
    var bundle = parseInt(el.dataset.bundlePrice, 10) || 0;
    var amount = parseInt(el.dataset.discountAmount, 10) || 0;
    var percent = parseInt(el.dataset.discountPercent, 10) || 0;
    var thisPrice = parseInt(el.dataset.thisPrice, 10) || 0;

    // Styckpriser (öre) och korgens faktiska avdrag för allt ur erbjudandet som ligger i varukorgen.
    var prices = [];
    var savedInCart = 0;
    (cart.items || []).forEach(function (item) {
      if (ids.indexOf(item.product_id) === -1) return;
      var unit = item.original_price != null ? item.original_price : item.price;
      for (var i = 0; i < item.quantity; i++) prices.push(unit);
      savedInCart += item.line_level_total_discount || 0;
    });

    var inCart = prices.length;
    var remainder = inCart % qty;
    var left = qty - 1 - remainder;
    var filled = remainder + 1;
    var ready = left === 0;
    var active = inCart >= qty;

    // Besparingen om den här läggs till: gruppen blir den här + de billigaste oparade i korgen.
    var save = parseInt(el.dataset.maxSave, 10) || 0;
    if (ready) {
      var unpaired = prices.slice().sort(function (a, b) { return a - b; }).slice(0, remainder);
      var group = unpaired.concat([thisPrice]);
      if (type === 'amount') {
        save = amount;
      } else if (type === 'percent') {
        save = Math.floor(Math.min.apply(null, group) * percent / 100);
      } else {
        save = group.reduce(function (sum, p) { return sum + p; }, 0) - bundle;
      }
      if (save < 0) save = 0;
    }

    var vars = {
      antal: String(left),
      erbjudande: el.dataset.offerLabel || '',
      spar: money(save),
      sparat: money(savedInCart)
    };
    var d = el.dataset;
    var textMore = active ? d.textMoreAgain : d.textMore;
    var textReady = active ? d.textReadyAgain : d.textReady;

    el.dataset.state = ready ? 'ready' : 'more';

    var text = el.querySelector('[data-jh-offer-text]');
    if (text) text.textContent = fill(ready ? textReady : textMore, vars);

    var label = el.querySelector('[data-jh-offer-label]');
    if (label) label.textContent = fill(ready ? el.dataset.labelReady : el.dataset.labelMore, vars);

    var activeEl = el.querySelector('[data-jh-offer-active]');
    if (activeEl) {
      activeEl.textContent = fill(d.textActive, vars);
      activeEl.classList.toggle('hidden', !active);
    }

    var bar = el.querySelector('[data-jh-offer-bar]');
    if (bar) bar.setAttribute('aria-valuenow', String(filled));
    el.querySelectorAll('[data-jh-seg]').forEach(function (seg, index) {
      seg.classList.toggle('is-filled', index + 1 < filled);
      seg.classList.toggle('is-next', index + 1 === filled);
    });
  }

  function refresh() {
    var els = document.querySelectorAll('[data-jh-offer]');
    if (!els.length) return;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        els.forEach(function (el) { render(el, cart); });
      })
      .catch(function () {
        // Tyst: Liquid-läget står kvar tills nästa händelse.
      });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay);
  }

  // Erbjudandets slut (data-ends, unix-sekunder): sidan kan ligga cachad efter att det gått ut.
  document.querySelectorAll('[data-jh-offer][data-ends]').forEach(function (el) {
    if (Date.now() / 1000 >= Number(el.dataset.ends)) el.remove();
  });

  EVENTS.forEach(function (name) {
    document.addEventListener(name, function () { schedule(150); });
  });
  // Antal ändras i varukorgen: händelsen skickas före anropet till Shopify, så vänta lite.
  document.addEventListener('theme:cart:update', function () { schedule(900); });
  // Sidan kan ha öppnats från bfcache med en gammal varukorg i Liquid-läget.
  window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(0); });
})();
